export const splitStylesAndHtml = (html) => {
    const styleRegex = /<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi;
    const bodyRegex = /<body[^>]*>([^<]*(?:(?!<\/?body)<[^<]*)*)<\/body\s*>/i;
    const styles = html.match(styleRegex)?.[0] || "";
    const bodyContent = html.match(bodyRegex)?.[1] || "";

    return { styles, bodyContent };
};
